import CasosExitoV2 from './CasosExitoV2';
export default CasosExitoV2;
